"use client";

import { c as _c } from "react/compiler-runtime";
import TeamMemberCard from "./TeamMemberCard";
const TeamGrid = t0 => {
  const $ = _c(4);
  const {
    members
  } = t0;
  let t1;
  if ($[0] !== members) {
    t1 = members.map(_temp);
    $[0] = members;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <section className="bg-[#0F1C2E] py-16 sm:py-24 md:py-32"><div className="max-w-[1280px] mx-auto px-4 sm:px-6 md:px-8"><div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12 sm:gap-x-8 sm:gap-y-16 md:gap-x-12 md:gap-y-24">{t1}</div></div></section>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default TeamGrid;
function _temp(member, index) {
  return <TeamMemberCard key={index} {...member} delay={index % 3 * 0.15} />;
}